import { useId } from 'react';

/*
 * The translucent blue body from the report covers in the mockups: a glassy
 * figure with soft lungs, heart, liver and stomach. Decorative only.
 */
export default function BodyFigure({ className, organs = true }) {
  const uid = useId();
  const body = `${uid}-body`;
  const glow = `${uid}-glow`;
  return (
    <svg className={className} viewBox="0 0 120 240" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={body} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#7fb2ff" stopOpacity="0.95" />
          <stop offset="0.55" stopColor="#a9caff" stopOpacity="0.75" />
          <stop offset="1" stopColor="#dbe9ff" stopOpacity="0.25" />
        </linearGradient>
        <radialGradient id={glow} cx="0.5" cy="0.35" r="0.6">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0.7" />
          <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
      </defs>
      <g fill={`url(#${body})`}>
        <ellipse cx="60" cy="22" rx="15" ry="18" />
        <path d="M52 38h16l1 9c16 3 25 11 27 25l7 58c1 6-7 8-9 2l-10-50-3 40 4 104H73l-7-84h-12l-7 84H34l4-104-3-40-10 50c-2 6-10 4-9-2l7-58c2-14 11-22 27-25Z" />
      </g>
      <path
        d="M52 38h16l1 9c16 3 25 11 27 25l7 58c1 6-7 8-9 2l-10-50-3 40 4 104H73l-7-84h-12l-7 84H34l4-104-3-40-10 50c-2 6-10 4-9-2l7-58c2-14 11-22 27-25Z"
        fill={`url(#${glow})`}
      />
      {organs && (
        <g>
          <path d="M46 62c-6 2-9 12-8 24 1 8 6 10 10 7 3-3 3-12 3-20 0-7-2-12-5-11Z" fill="#8fb4f4" opacity="0.85" />
          <path d="M74 62c6 2 9 12 8 24-1 8-6 10-10 7-3-3-3-12-3-20 0-7 2-12 5-11Z" fill="#8fb4f4" opacity="0.85" />
          <path d="M60 74c-5-5-12 0-9 6 2 4 9 9 9 9s7-5 9-9c3-6-4-11-9-6Z" fill="#ef5b6b" opacity="0.9" />
          <path d="M44 98c6-4 18-4 22 0 3 3 0 9-6 10-7 1-15-1-17-4-1-2-1-4 1-6Z" fill="#c9785a" opacity="0.8" />
          <ellipse cx="72" cy="104" rx="7" ry="5" fill="#f2a65a" opacity="0.8" />
          <path d="M50 116c4 6 16 6 20 0" fill="none" stroke="#f2b8a0" strokeWidth="5" strokeLinecap="round" opacity="0.7" />
        </g>
      )}
    </svg>
  );
}
